import React, { useState } from 'react';
import { Input } from '../../components/Input';
import { Button } from '../../components/Button';
import { SuccessMessage } from './SuccessMessage';
const interestOptions = ['E-commerce solutions', 'Data import/export systems', 'MySQL database services', 'E-business applications', 'Global File System (GFS)', 'Custom web programming', 'Graphic design & UI/UX', 'Mobile app development (iOS/Android)', 'System integrations (API/EDI/XML)', 'AI & automation'];
export function ContactForm() {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: '',
    referrer: '',
    projectSummary: '',
    phone: '',
    budget: '',
    timeline: '',
    interests: [] as string[]
  });
  const [errors, setErrors] = useState<Record<string, string>>({});
  const validateForm = () => {
    const newErrors: Record<string, string> = {};
    if (!formData.name.trim()) newErrors.name = 'Please enter your name';
    if (!formData.email.trim()) newErrors.email = 'Please enter a valid email address';else if (!/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Please enter a valid email address';
    if (!formData.referrer.trim()) newErrors.referrer = 'Please let us know who referred you';
    if (!formData.projectSummary.trim()) newErrors.projectSummary = 'Please provide a brief project description';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (validateForm()) {
      console.log('Form submitted:', formData);
      setSubmitted(true);
    }
  };
  const handleInterestToggle = (interest: string) => {
    setFormData(prev => ({
      ...prev,
      interests: prev.interests.includes(interest) ? prev.interests.filter(i => i !== interest) : [...prev.interests, interest]
    }));
  };
  if (submitted) {
    return <SuccessMessage data-id="element-236" />;
  }
  return <form onSubmit={handleSubmit} className="bg-surface rounded-2xl p-8 md:p-12 load-fade-in-up stagger-3" data-id="element-237">
      <div className="space-y-6" data-id="element-238">
        <Input label="Full Name" type="text" placeholder="John Smith" value={formData.name} onChange={value => setFormData({
        ...formData,
        name: value
      })} error={errors.name} required data-id="element-239" />
        <Input label="Email Address" type="email" placeholder="john@company.com" value={formData.email} onChange={value => setFormData({
        ...formData,
        email: value
      })} error={errors.email} required data-id="element-240" />
        <Input label="Company Name" type="text" placeholder="Acme Corporation" value={formData.company} onChange={value => setFormData({
        ...formData,
        company: value
      })} data-id="element-241" />
        <Input label="Who referred you to Magnus Software?" type="text" placeholder="Name or company that recommended us" value={formData.referrer} onChange={value => setFormData({
        ...formData,
        referrer: value
      })} error={errors.referrer} helperText="We accept new projects by referral to ensure the best fit. If you're not sure who to list, a mutual connection or professional contact works too." required data-id="element-242" />
        <Input label="Tell us about your project" type="textarea" placeholder="Describe what you're looking to build, the problem you're solving, or the goals you want to achieve..." value={formData.projectSummary} onChange={value => setFormData({
        ...formData,
        projectSummary: value
      })} error={errors.projectSummary} helperText="A few sentences about your needs helps us prepare for our conversation." rows={5} required data-id="element-243" />
        <Input label="Phone Number" type="tel" placeholder="(555) 123-4567" value={formData.phone} onChange={value => setFormData({
        ...formData,
        phone: value
      })} data-id="element-244" />

        <div className="flex flex-col gap-1.5" data-id="element-245">
          <label className="text-sm font-semibold text-ink" data-id="element-246">
            Estimated Budget
          </label>
          <select value={formData.budget} onChange={e => setFormData({
          ...formData,
          budget: e.target.value
        })} className="w-full px-4 py-3 border border-neutral rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white" data-id="element-247">
            <option value="" data-id="element-248">Select a range</option>
            <option value="prefer-not-to-say" data-id="element-249">Prefer not to say</option>
            <option value="under-25k" data-id="element-250">Under $25,000</option>
            <option value="25k-50k" data-id="element-251">$25,000 - $50,000</option>
            <option value="50k-100k" data-id="element-252">$50,000 - $100,000</option>
            <option value="100k-250k" data-id="element-253">$100,000 - $250,000</option>
            <option value="250k-plus" data-id="element-254">$250,000+</option>
          </select>
        </div>

        <div className="flex flex-col gap-1.5" data-id="element-255">
          <label className="text-sm font-semibold text-ink" data-id="element-256">
            Desired Timeline
          </label>
          <select value={formData.timeline} onChange={e => setFormData({
          ...formData,
          timeline: e.target.value
        })} className="w-full px-4 py-3 border border-neutral rounded-lg transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent bg-white" data-id="element-257">
            <option value="" data-id="element-258">Select a timeline</option>
            <option value="flexible" data-id="element-259">Flexible</option>
            <option value="1-3-months" data-id="element-260">1-3 months</option>
            <option value="3-6-months" data-id="element-261">3-6 months</option>
            <option value="6-12-months" data-id="element-262">6-12 months</option>
            <option value="12-plus-months" data-id="element-263">12+ months</option>
          </select>
        </div>

        <div className="flex flex-col gap-3" data-id="element-264">
          <label className="text-sm font-semibold text-ink" data-id="element-265">
            What services are you interested in? (select all that apply)
          </label>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3" data-id="element-266">
            {interestOptions.map(interest => <label key={interest} className="flex items-center gap-3 p-3 bg-white rounded-lg border border-neutral cursor-pointer hover:border-primary transition-colors" data-id="element-267">
                <input type="checkbox" checked={formData.interests.includes(interest)} onChange={() => handleInterestToggle(interest)} className="w-4 h-4 text-primary border-neutral rounded focus:ring-2 focus:ring-primary" data-id="element-268" />
                <span className="text-sm text-gray-700" data-id="element-269">{interest}</span>
              </label>)}
          </div>
        </div>

        <div className="pt-4" data-id="element-270">
          <p className="text-sm text-gray-600 mb-6" data-id="element-271">
            Don't have a referral? We occasionally consider projects that align
            exceptionally well with our expertise. Feel free to share your
            connection to Magnus Software or how you found us.
          </p>
          <Button type="submit" variant="primary" size="lg" className="w-full" data-id="element-272">
            Submit Inquiry
          </Button>
        </div>
      </div>
    </form>;
}